import type { Nullable } from "@sunrise/utils";

import type { UserToken } from "./jwt.types";

export const queryKeys = {
  userToken: (at: Nullable<UserToken>) => ["at", at] as const,
};
